import { EventDistance } from './types';

/**
 * Platzhalter für eine fehlende Streckenkarte, gemeinsam für Web (`EventDetail`) und App
 * (`event/[id]`).
 *
 * Hat bei einem Event nur ein Teil der Distanzen eine Karte (etwa 3 von 5 GPX-Dateien
 * gefunden), springt die Detailseite beim Umschalten: mal steht oben eine Karte, mal fehlt
 * der ganze Block. Der Platzhalter hält die Stelle frei.
 *
 * Er erscheint nur, wenn **mindestens eine andere** Distanz eine Karte hat. Ein Event ganz
 * ohne Strecken bleibt wie bisher ohne Kartenblock; dort wäre ein leerer Kasten nur Lärm.
 */

/** Welche Distanz auf der jeweiligen Plattform eine Karte zeichnet. */
export type HasRouteMap = (d: EventDistance) => boolean;

/** Web: eine GPX-Datei oder ein Streckenlink (Komoot, AllTrails, …) füllt den Kartenblock. */
export const hasRouteMapWeb: HasRouteMap = d => !!d.hasGpx || !!d.routeUrl;

/** App: gezeichnet wird nur aus der GPX-Datei, der Streckenlink steht weiter unten. */
export const hasRouteMapApp: HasRouteMap = d => !!d.hasGpx;

export function showRoutePlaceholder(
  distances: EventDistance[],
  selected: EventDistance | undefined,
  hasMap: HasRouteMap = hasRouteMapWeb,
): boolean {
  if (!selected || hasMap(selected)) return false;
  return distances.some(d => d.id !== selected.id && hasMap(d));
}

/** Texte des Platzhalters, identisch in Web und App. */
export const ROUTE_PLACEHOLDER = {
  title: 'Keine Streckenkarte',
  text: 'Für diese Distanz liegt noch kein Streckenverlauf vor.',
} as const;
